import React, { useState } from 'react';
import { logo } from '../images/images';
import cv from '../images/CV.png';

const Rule = ({ color }) => (
  <hr
    style={{
      borderColor: color,
    }}
  />
);

const LeftSide = () => {
  const [isActive, setIsActive] = useState(false);
  const [showMe, setShowMe] = useState(false);

  return (
    <>
      <div className="w3-col m3 left-side">
        <div className="w3-card w3-round" id="home">
          <div className="w3-container left">
            <h4 className="w3-center title_profile">Profile</h4>
            <p className="w3-center">
              <img
                src={logo}
                className="w3-circle"
                style={{ height: 106, width: 106, objectFit: 'cover' }}
                alt="Avatar"
              />
            </p>
            <Rule color="#49a6e9" />
            <p className="desc">
              <i className="fa fa-pencil fa-fw w3-margin-right pencil"></i>
              Web Developer
            </p>
            <p className="desc">
              <i className="fa fa-home fa-fw w3-margin-right house"></i>
              Kruisem, BE
            </p>
            <p>
              <i className="fa fa-linkedin fa-fw w3-margin-right in"></i>
              <a
                className="desc"
                rel="noreferrer"
                href="https://www.linkedin.com/in/pislaru-g-316205231/"
                target="_blank"
              >
                linkedin
              </a>
            </p>
          </div>
        </div>
        <br />

        <div className="w3-card w3-round" id="skills">
          <div className="skills_container">
            <p className="w3-center skills">My Skills</p>
            <p className="w3-center see_below">Click the buttons below</p>
            <button
              onClick={() => setIsActive(!isActive)}
              className="btn w3-block w3-left-align"
            >
              <i className="fa fa-circle-o-notch fa-fw w3-margin-right text-green"></i>
              <span className="btn_f">FrontEnd</span>
            </button>
            {isActive && (
              <div id="Demo1" className="w3-container">
                <p>React JS</p>
                <p>React Native</p>
                <p>Next JS</p>
                <p>Javascript</p>
                <p>Html5 & Css3</p>
                <p>Tailwindcss</p>
                <p>Bootstrap</p>
              </div>
            )}

            <button
              onClick={() => setShowMe(!showMe)}
              className="btn w3-block w3-left-align"
            >
              <i className="fa fa-circle-o-notch fa-fw w3-margin-right text-red"></i>
              <span className="btn_f">BackEnd</span>
            </button>
            {showMe && (
              <div id="Demo2" className="w3-container">
                <p>Python</p>
                <p>PHP</p>
                <p>Node JS</p>
                <p>MongoDB</p>
                <p>SanityIo</p>
              </div>
            )}
          </div>
        </div>
        <br />

        <div className="w3-card w3-round w3-white w3-hide-small interese">
          <div className="w3-container">
            <p className="desc">Interests</p>
            <p>
              <span className="w3-tag w3-small">IT</span>
              <span className="w3-tag w3-small">React</span>
              <span className="w3-tag w3-small">Next</span>
              <span className="w3-tag w3-small">Family</span>
              <span className="w3-tag w3-small">Friends</span>
              <span className="w3-tag w3-small">Games</span>
              <span className="w3-tag w3-small">Design</span>
              <span className="w3-tag w3-small">Art</span>
              <span className="w3-tag w3-small">Sport</span>
            </p>
          </div>
        </div>
        <br />
        <div className="w3-card w3-round w3-white w3-hide-small cv_section">
          <div className="w3-container">
            <p className="desc">See my CV</p>
            <i class="fa fa-bookmark w3-xlarge" aria-hidden="true"></i>
            <br />
            <br />
            <a
              href="https://mycv-react.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              <img className="cv" src={cv} alt="cv" style={{ width: '100%' }} />
            </a>
          </div>
        </div>
        <br />

        <div className="w3-card w3-round w3-white w3-hide-small about_section">
          <div className="w3-container">
            <p className="desc">About Me</p>
            <i class="fa fa-bookmark w3-xlarge" aria-hidden="true"></i>
            <br />
            <br />
            <h3 className="about_title">Hi, I am Geo</h3>
            <h4 className="about_subtitle">A freelance Web developer</h4>
            <p className="desc">
              I am a freelance website designer and developer from Belgium,
              Kruisem. I create professional websites. I love art and always try
              to show unique views to the audience through my design, I am
              somebody who like to listen to people, reaching goals, always
              positive.
            </p>

            <h3 className="about_subtitle">Contact</h3>
            <a
              href="mailto:icreateandbuild@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="desc"
            >
              icreateandbuild@gmail.com
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftSide;
